import {NotixApi} from "./api";

class AudiencePixels {
  load() {
    return NotixApi.get("/pixels");
  }
  //
  create(addAudienceId, delAudienceId, status) {
    return NotixApi.post("/pixels/add", {
      add_audience_id: addAudienceId,
      del_audience_id: delAudienceId,
      status: status,
    });
  }

  delete(addAudienceId, delAudienceId, uid) {
    return NotixApi.post("/pixels/delete", {
      uid: uid,
      add_audience_id: addAudienceId,
      del_audience_id: delAudienceId,
      status: 2,
    });
  }

  update(addAudienceId, delAudienceId, uid, status) {
    return NotixApi.post(`/pixels/update`, {
      add_audience_id: addAudienceId,
      del_audience_id: delAudienceId,
      status: status,
      uid: uid,
    });
  }
}

const audiencePixelsInstance = new AudiencePixels();

export default audiencePixelsInstance;